import { render, staticRenderFns } from "./CheckboxSP.vue?vue&type=template&id=1c7804da&scoped=true&"
import script from "./CheckboxSP.vue?vue&type=script&lang=js&"
export * from "./CheckboxSP.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSP.vue?vue&type=style&index=0&id=1c7804da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7804da",
  null
  
)

export default component.exports